import styled from '@emotion/styled';

export const InputUnderlined = styled.input(({ theme }) => ({
  fontSize: 16,
  padding: 8,
  width: 250,
  height: 38,
  border: 'none',
  borderBottom: `1px solid ${theme.palette.gray.light1} `,
  fontFamily: theme.fonts.regular,

  '&:focus': {
    borderColor: theme.isTrinityThemed ? theme.palette.blue.main : theme.palette.primary.main,
    borderWidth: 2,
  },

  '&::placeholder': {
    // color: theme.palette.gray.light1,
    fontFamily: theme.fonts.regular,
    fontSize: 14,
  },
}));